<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="form.id ? '编辑班组排班' : '新增班组排班'"
    width="650px"
    top="8vh"
    @closed="resetForm"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="班组" prop="teamId">
        <el-input v-model="teamName" placeholder="请选择班组" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.teamSelect.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="生产班组日历" prop="calendarId">
        <el-input v-model="calendarName" placeholder="选择班组后自动带出，也可手动选择" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.calendarSelect.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="排班月份" prop="rotaMonth">
        <el-date-picker v-model="form.rotaMonth" type="month" value-format="yyyy-MM" placeholder="请选择排班月份" style="width:100%"/>
      </el-form-item>
      <el-form-item label="排班日期" prop="rotaDate">
        <el-date-picker v-model="form.rotaDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择排班日期" style="width:100%" @change="handleRotaDateChange"/>
      </el-form-item>
      <el-form-item label="班次模板">
        <el-select v-model="form.calShiftRefId" placeholder="请选择班次" style="width:100%" @change="handleShiftChange">
          <el-option
            v-for="item in shiftOptions"
            :key="item.refId"
            :label="item.shiftName"
            :value="item.refId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="上班时间">
        <el-input :value="formatTime(form.workStart)" placeholder="选择班次后自动带出" readonly/>
      </el-form-item>
      <el-form-item label="下班时间">
        <el-input :value="formatTime(form.workEnd)" placeholder="选择班次后自动带出" readonly/>
      </el-form-item>
      <el-form-item label="休息时间">
        <el-input :value="formatRestTime(form.restStart, form.restEnd)" placeholder="选择班次后自动带出" readonly/>
      </el-form-item>
      <el-form-item label="标准工时">
        <el-input-number v-model="form.standardWorkHour" :min="0" :precision="2" controls-position="right" style="width:100%"/>
      </el-form-item>
      <el-form-item label="是否允许加班">
        <el-input :value="formatCanOvertime(form.canOvertime)" placeholder="选择班次后自动带出" readonly/>
      </el-form-item>
      <el-form-item label="最大加班时长">
        <el-input :value="form.overtimeMaxHour != null ? form.overtimeMaxHour + ' 小时' : ''" placeholder="选择班次后自动带出" readonly/>
      </el-form-item>
      <el-form-item label="员工工号">
        <el-input v-model="form.empNo" placeholder="请输入员工工号"/>
      </el-form-item>
      <el-form-item label="员工姓名">
        <el-input v-model="form.empName" placeholder="请输入员工姓名"/>
      </el-form-item>
      <el-form-item label="是否借调">
        <el-select v-model="form.isBorrow" placeholder="请选择" style="width:100%">
          <el-option label="本班组人员" :value="0"/>
          <el-option label="内部借调支援" :value="1"/>
          <el-option label="外协临时支援借调" :value="3"/>
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入排班备注"/>
      </el-form-item>
    </el-form>

    <team-select ref="teamSelect" @select="selectTeam"/>

    <calendar-select
      ref="calendarSelect"
      title="选择生产班组日历"
      :filter="calendarFilter"
      @select="selectCalendar"
    />

    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submitHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import TeamSelect from "./TeamSelect";
  import CalendarSelect from "../calendar/CalendarSelect";

  export default {
    name: "TeamShiftRotaEdit",
    components: { TeamSelect, CalendarSelect },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        teamName: "",
        calendarName: "",
        shiftOptions: [],
        calendarFilter: { calendarType: 5, calendarName: "" },
        form: {},
        rules: {
          teamId: [{ required: true, message: "请选择班组", trigger: "change" }],
          calendarId: [{ required: true, message: "请选择生产班组日历", trigger: "change" }],
          rotaDate: [{ required: true, message: "请选择排班日期", trigger: "change" }],
        },
      };
    },
    methods: {
      formatTime(time) {
        return time ? time.substring(0, 5) : "";
      },
      formatRestTime(restStart, restEnd) {
        if (!restStart && !restEnd) return "";
        return `${this.formatTime(restStart)} ~ ${this.formatTime(restEnd)}`;
      },
      formatCanOvertime(val) {
        if (val === null || val === undefined) return "";
        return val === 1 ? "是" : "否";
      },
      resetForm() {
        this.form = {};
        this.teamName = "";
        this.calendarName = "";
        this.shiftOptions = [];
        this.$refs.form && this.$refs.form.resetFields();
      },
      open(row) {
        this.dialogVisible = true;
        this.shiftOptions = [];
        if (row && row.id) {
          this.form = { ...row };
          this.teamName = row.teamName || "";
          this.calendarName = row.calendarName || "";
        } else {
          this.form = {
            teamId: null,
            calendarId: null,
            rotaMonth: "",
            rotaDate: "",
            calShiftRefId: null,
            empId: null,
            empNo: "",
            empName: "",
            standardWorkHour: null,
            isBorrow: 0,
            remark: "",
          };
          this.teamName = "";
          this.calendarName = "";
        }
      },
      selectTeam(row) {
        this.form.teamId = row.id;
        this.teamName = row.teamName;
        // 自动带出班组绑定的专属班组日历
        if (row.defaultCalendarId) {
          this.form.calendarId = row.defaultCalendarId;
          this.calendarName = row.calendarName || row.defaultCalendarName || "";
          // 若已选排班日期，则重新加载该日历下的班次
          if (this.form.rotaDate) {
            this.loadShiftOptions();
          }
        }
      },
      selectCalendar(row) {
        this.form.calendarId = row.id;
        this.calendarName = row.calendarName;
        this.form.calShiftRefId = null;
        if (this.form.rotaDate) {
          this.loadShiftOptions();
        }
      },
      handleRotaDateChange() {
        this.form.calShiftRefId = null;
        if (this.form.calendarId && this.form.rotaDate) {
          this.loadShiftOptions();
        }
      },
      loadShiftOptions() {
        if (!this.form.calendarId || !this.form.rotaDate) return;
        this.$http.get("basic", `fm/calendarShift/listByDate/${this.form.calendarId}`, {
          targetDate: this.form.rotaDate,
        }).then((resp) => {
          if (resp.success) {
            this.shiftOptions = resp.data || [];
            // 编辑回显时优先定位原班次；否则默认选中第一个
            let target = null;
            if (this.form.calShiftRefId != null) {
              target = this.shiftOptions.find((s) => s.refId === this.form.calShiftRefId);
            }
            if (!target && this.shiftOptions.length > 0) {
              target = this.shiftOptions[0];
            }
            if (target) {
              this.applyShift(target);
            }
          }
        });
      },
      handleShiftChange(refId) {
        const target = this.shiftOptions.find((s) => s.refId === refId);
        if (target) {
          this.applyShift(target);
        }
      },
      applyShift(shift) {
        this.form.calShiftRefId = shift.refId;
        this.form.workStart = shift.workStart;
        this.form.workEnd = shift.workEnd;
        this.form.restStart = shift.restStart;
        this.form.restEnd = shift.restEnd;
        this.form.canOvertime = shift.canOvertime;
        this.form.overtimeMaxHour = shift.overtimeMaxHour;
        // 标准工时有班次有效工时带出，允许微调
        if (shift.effectWorkHour != null && (this.form.standardWorkHour == null || this.form.standardWorkHour === 0)) {
          this.form.standardWorkHour = shift.effectWorkHour;
        }
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (!valid) return;
          this.loading = true;
          this.$http.save("basic", "mES_TeamShiftRotas", this.form)
            .then((resp) => {
              if (resp.success) {
                this.$message.success(this.form.id ? "编辑成功" : "新增成功");
                this.dialogVisible = false;
                this.$emit("save-success");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });
      },
    },
  };
</script>
